import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import axios from 'axios';

import { API } from '@/utils/api';

/**
 * AuthCallback - Handles Google OAuth callback from Emergent Auth
 * 
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS
 * This breaks the auth flow!
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        console.log('[GoogleAuth] Processing callback, hash:', hash ? hash.substring(0, 50) + '...' : 'empty');
        
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('[GoogleAuth] No session_id found in URL hash');
          navigate('/login', { replace: true, state: { error: 'Brak session_id w odpowiedzi Google' } });
          return;
        }

        const sessionId = sessionIdMatch[1];
        console.log('[GoogleAuth] Session ID extracted, length:', sessionId.length);

        // Exchange session_id for user data via backend
        console.log('[GoogleAuth] Calling backend /auth/google/session...');
        const response = await axios.post(`${API}/auth/google/session`, {
          session_id: sessionId
        }, {
          withCredentials: true
        });

        console.log('[GoogleAuth] Backend response received');
        const { token, user } = response.data;

        // Store token in localStorage
        localStorage.setItem('token', token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        // Clear the URL hash and redirect to dashboard
        window.history.replaceState(null, '', '/panel');
        navigate('/panel', { replace: true, state: { user } });

      } catch (error) {
        const status = error?.response?.status;
        const data = error?.response?.data;
        const errorCode = data?.detail?.error_code || 'UNKNOWN';
        const requestId = data?.detail?.request_id || 'N/A';
        const message = data?.detail?.message || data?.detail || 'Błąd logowania przez Google';
        
        console.error(`[GoogleAuth] Error [${requestId}]: ${errorCode}`, { status, data });
        
        navigate('/login', { 
          replace: true, 
          state: { 
            error: typeof message === 'string' ? message : 'Błąd logowania przez Google. Spróbuj ponownie.',
            errorCode,
            requestId
          } 
        });
      }
    };

    processSession();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#0B0F1A] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-blue-400 animate-spin mx-auto mb-4" />
        <p className="text-gray-400">Logowanie przez Google...</p>
      </div>
    </div>
  );
}
